// extracted by mini-css-extract-plugin
module.exports = {"display_text":"display_text_display_text__28qb6"};